import React from 'react';
import { Callout, P, Sub, Table, UI } from '../ui';

export const WindowTray: React.FC = () => (
  <>
    <Callout tone="danger" title="닫기(×)를 눌러도 앱은 꺼지지 않습니다">
      <p>
        메신저 특성상 알림을 계속 받아야 하므로, 창을 닫으면 종료되지 않고 <b>트레이(작업표시줄 오른쪽 시계 옆)로
        숨습니다.</b> 완전히 끄려면 트레이 아이콘을 마우스 오른쪽 버튼으로 클릭한 뒤 <UI>종료</UI>를 선택하세요.
      </p>
    </Callout>

    <Sub anchor="window-buttons">창 버튼</Sub>
    <Table
      head={['버튼', '동작']}
      rows={[
        ['─', '최소화. 작업표시줄에 남고, 작업표시줄 아이콘을 누르면 다시 열립니다'],
        ['□', '최대화 / 이전 크기로 되돌리기'],
        ['×', '트레이로 이동 (종료 아님)'],
      ]}
    />
    <P>제목 표시줄의 빈 공간을 드래그하면 창을 옮길 수 있고, 가장자리를 끌어 크기를 조절할 수 있습니다.</P>

    <Sub>트레이 아이콘 사용법</Sub>
    <Table
      head={['조작', '결과']}
      rows={[
        ['아이콘 왼쪽 클릭', '창이 열리면서 앞으로 나옵니다'],
        [
          '아이콘 오른쪽 클릭',
          <>
            메뉴 세 가지: <UI>열기</UI> · <UI>알림 받기</UI>(체크) · <UI>종료</UI>
          </>,
        ],
      ]}
    />
    <Callout tone="tip">
      <p>
        트레이 아이콘이 보이지 않는다면 시계 옆의 <b>&lsquo;∧&rsquo; 화살표</b>를 눌러 숨겨진 아이콘을 펼쳐
        보세요. 자주 쓴다면 아이콘을 작업표시줄로 끌어다 놓으면 항상 보이게 할 수 있습니다.
      </p>
    </Callout>

    <Sub>알림이 오면 창이 어떻게 되나요</Sub>
    <P>
      트레이에 숨어 있을 때 메시지가 오면 <b>작업표시줄에 최소화된 상태로 나타나며 깜빡입니다.</b> 작업 중인 화면을
      가로채지 않으므로 하던 일을 방해받지 않고, 확인하고 싶을 때 클릭하면 됩니다.
    </P>
    <P>
      작업표시줄 아이콘의 오른쪽 아래에는 <b>안 읽은 메시지 개수</b>가 함께 표시됩니다. 100건이 넘으면 99+로 보이고,
      메시지를 모두 읽으면 숫자와 깜빡임이 함께 사라집니다.
    </P>
    <P>Windows 알림 팝업을 클릭하면 창이 열리면서 메시지가 온 대화방으로 바로 이동합니다.</P>

    <Sub>PC를 켜면 자동으로 실행됩니다</Sub>
    <P>
      기본 설정으로 Windows 시작 시 INA-TALK이 자동 실행됩니다. 이때는 창이 뜨지 않고 <b>트레이에서 조용히
      시작</b>하므로 부팅 직후 화면을 가리지 않습니다.
    </P>
    <P>
      원하지 않으면 <UI>설정</UI> → <UI>PC 시작 시 자동 실행</UI>을 끄면 됩니다. 다만 자동 실행을 꺼두면 앱을 직접
      켜기 전까지 알림을 받지 못합니다.
    </P>
  </>
);
